import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";

export const ExpandCollapseIconStyled = styled(SVG_MUI.ArrowStatCollapse3SVG)<{
  $isExpanded: boolean;
}>`
  transform: rotate(
    ${({ $isExpanded: isExpanded }) => (isExpanded ? "0deg" : "180deg")}
  );
`;
